import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var Line = function Line() {
  return _jsx("hr", {
    style: {
      color: 'var(--disabled-2)',
      border: '1px solid var(--disabled-2)',
      height: 0.5,
      width: "100%"
    }
  });
};